import { FileXIcon } from '@phosphor-icons/react'
import { ImgHTMLAttributes, ReactNode } from 'react'

import { Icon } from '@/components/ui/icon'
import { useImageFallback } from '@/hooks/use-image-fallback'

import * as S from './image-with-fallback.styled'

interface ImageWithFallbackProps extends ImgHTMLAttributes<HTMLImageElement> {
  fallback?: ReactNode
}

export const ImageWithFallback = ({
  alt,
  className,
  fallback,
  src,
  style,
  ...rest
}: ImageWithFallbackProps) => {
  const { hasError, onError } = useImageFallback(src)

  if (hasError) {
    return (
      <S.Fallback
        aria-label={alt}
        className={className}
        data-component-id="ImageWithFallback"
        role="img"
        style={style}
      >
        {fallback ?? <Icon color="black300" icon={FileXIcon} size="3.2rem" />}
      </S.Fallback>
    )
  }

  return <img {...rest} alt={alt} className={className} src={src} style={style} onError={onError} />
}
